import state from './versionhistory.state'
import mutations from './versionhistory.mutations'
import actions from './versionhistory.actions'

export default {
  state,
  mutations,
  actions
}
